module.exports = __webpack_public_path__ + "static/img/bg-Client-05.5cf7aa70.png";